import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
} from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { RenderedService } from "../../rendered.service";
import { BaseScaffoldComponent } from "../base-scaffold/base-scaffold.component";

@Component({
  selector: "scaffold-accordion",
  templateUrl: "./accordion.component.html",
  styleUrls: ["../../rendered.component.scss", "./accordion.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
/*
 * this component collapses and expands an accordion
 */
export class AccordionComponent
  extends BaseScaffoldComponent
  implements OnInit, OnDestroy
{
  public destroy$: Subject<boolean> = new Subject<boolean>();
  constructor(
    public cdr: ChangeDetectorRef,
    public renderedService: RenderedService
  ) {
    super(cdr, renderedService);
  }  

  expandedTabs: any[] = [];

  ngOnInit() {
    this.renderedService
      .listenForUpdates()
      .pipe(takeUntil(this.destroy$))
      .subscribe((trigger) => {
        if (!this.cdr["destroyed"]) {
          this.cdr.detectChanges();
        }
      });
    this.expandedTabs = this.item?.tabs?.filter((tab) => tab.expanded).map((tab, index) => index);
  }
  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
